var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgLands(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M27.531 22.795a.469.469 0 010 .937c-3.667 0-7.267 1.505-9.877 4.13a.467.467 0 01-.663.001.469.469 0 01-.001-.662c2.784-2.8 6.626-4.406 10.541-4.406zm-9.775-.434a.469.469 0 01-.126.65 17.564 17.564 0 00-4.778 4.782.469.469 0 11-.778-.523 18.502 18.502 0 015.032-5.035.469.469 0 01.65.126zM15.836 8a.42.42 0 01.41.352l.007.077v1.285h7.497V8.43c0-.237.187-.429.417-.429a.42.42 0 01.41.352l.006.077v7.3c.975-.133 1.96-.2 2.948-.2a.469.469 0 010 .938c-1.47 0-2.923.156-4.341.457a21.365 21.365 0 00-12.52 7.92 20.93 20.93 0 00-.92 1.308l-.284.453-.714 1.17a.469.469 0 01-.838-.412l.037-.076.715-1.17c.29-.475.597-.937.92-1.387a13.719 13.719 0 00-5.117-.99.469.469 0 010-.937c1.962 0 3.878.387 5.702 1.152.615-.78 1.28-1.517 1.993-2.207a17.696 17.696 0 00-7.695-1.781.469.469 0 010-.938c2.904 0 5.813.704 8.432 2.038.7-.618 1.44-1.193 2.214-1.72A21.142 21.142 0 004.47 16.476a.469.469 0 110-.938 22.2 22.2 0 011.549.055l.513.042.555.063V8.429c0-.237.187-.429.417-.429a.42.42 0 01.41.352l.007.077v1.285h7.497V8.429c0-.21.147-.386.341-.422L15.833 8h.004zm11.695 11.021a.469.469 0 110 .938c-1.989 0-3.958.34-5.852 1.01a.469.469 0 11-.313-.884 18.435 18.435 0 016.165-1.064zm-8.45-1.721h-5.828c1.44.555 2.433 1.03 2.747 1.03.198 0 1.553-.481 2.998-1l.083-.03zm4.668-1.442l.001-.572-7.497-.001V16.5h5.072c.54-.187.98-.334 1.222-.398l.08-.02.939-.192.183-.032zm-8.332-.573H7.92l-.001.524.043.006a22.305 22.305 0 012.967.685h4.49v-.358h-.002v-.857zM20 12.989l-2.545 1.44h5.09L20 12.989zm-8.33 0l-2.545 1.44h5.09l-2.545-1.44zm12.08-2.121L20.865 12.5l2.885 1.632v-3.264zm-15.83 0v3.264l2.885-1.632-2.885-1.632zm7.497.001L12.535 12.5l2.882 1.63v-3.261zm.836 0v3.261l2.882-1.63-2.882-1.631zm6.292-.298h-5.09L20 12.011l2.545-1.44zm-8.33 0h-5.09l2.545 1.44 2.545-1.44z"
  }));
}

export default SvgLands;